import type { IdentityFormType, IdentityServerType } from '@/lib/types/identity.types'

export const normalizeIdentity = (identity: IdentityServerType): IdentityFormType => {
  return {
    email: identity.email,
    phone: identity.phone,
  }
}

export const serializeIdentity = (data: IdentityFormType) => ({
  email: data.email,
  ...(data.phone && { phone: data.phone }),
})
